// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/staff.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/staff.proto.
 */
export const file_api_proto_v1_staff: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message api_proto.v1.GetStaffMeRequest
 */
export type GetStaffMeRequest = Message<"api_proto.v1.GetStaffMeRequest"> & {
};

/**
 * Describes the message api_proto.v1.GetStaffMeRequest.
 * Use `create(GetStaffMeRequestSchema)` to create a new message.
 */
export const GetStaffMeRequestSchema: GenMessage<GetStaffMeRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_staff, 0);

/**
 * @generated from message api_proto.v1.LogoutRequest
 */
export type LogoutRequest = Message<"api_proto.v1.LogoutRequest"> & {
};

/**
 * Describes the message api_proto.v1.LogoutRequest.
 * Use `create(LogoutRequestSchema)` to create a new message.
 */
export const LogoutRequestSchema: GenMessage<LogoutRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_staff, 1);

/**
 * @generated from message api_proto.v1.LogoutResponse
 */
export type LogoutResponse = Message<"api_proto.v1.LogoutResponse"> & {
};

/**
 * Describes the message api_proto.v1.LogoutResponse.
 * Use `create(LogoutResponseSchema)` to create a new message.
 */
export const LogoutResponseSchema: GenMessage<LogoutResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_staff, 2);

/**
 * @generated from message api_proto.v1.GetStaffResponse
 */
export type GetStaffResponse = Message<"api_proto.v1.GetStaffResponse"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 company_id = 2;
   */
  companyId: bigint;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: bool is_set_password = 5;
   */
  isSetPassword: boolean;

  /**
   * @generated from field: bool archived = 6;
   */
  archived: boolean;

  /**
   * LINE Messaging API の userId。未連携は空文字
   *
   * @generated from field: string line_id = 7;
   */
  lineId: string;

  /**
   * 匿名化済みか（Admin の退職処理。openspec/changes/archive/2026-10-09-admin-staff-offboarding）。
   * 判定はサーバー（models.CompanyStaff.IsAnonymized）が行い、フロントは氏名の文言で判定しない
   *
   * @generated from field: bool anonymized = 9;
   */
  anonymized: boolean;

  /**
   * ハウスケープのサポートアカウントか（決定125）。座席に数えず、support_access_until の間だけログインできる
   *
   * @generated from field: bool is_support = 10;
   */
  isSupport: boolean;

  /**
   * サポートアカウントがログインできる期限（RFC3339）。空＝OFF。期限切れでも値は残る（ONかは support_access_active で判断する）
   *
   * @generated from field: string support_access_until = 11;
   */
  supportAccessUntil: string;

  /**
   * いまログインできる状態（ON）か。サーバーが現在時刻で判定する（models.CompanyStaff.SupportAccessActive）。
   * フロントは端末の時計と期限を比べない
   *
   * @generated from field: bool support_access_active = 12;
   */
  supportAccessActive: boolean;
};

/**
 * Describes the message api_proto.v1.GetStaffResponse.
 * Use `create(GetStaffResponseSchema)` to create a new message.
 */
export const GetStaffResponseSchema: GenMessage<GetStaffResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_staff, 3);

/**
 * @generated from message api_proto.v1.GetStaffAuthResponse
 */
export type GetStaffAuthResponse = Message<"api_proto.v1.GetStaffAuthResponse"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 company_id = 2;
   */
  companyId: bigint;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: bool is_set_password = 5;
   */
  isSetPassword: boolean;

  /**
   * LINE Messaging API の userId。未連携は空文字
   *
   * @generated from field: string line_id = 7;
   */
  lineId: string;

  /**
   * 所属企業名
   *
   * @generated from field: string company_name = 9;
   */
  companyName: string;

  /**
   * 企業の実効機能集合（契約由来 + 企業オーバーライド。スタッフ個別権限との積を取る前）。
   * 「企業が未契約なので使えない」（プランバッジ + 閲覧のみ表示）と
   * 「スタッフ個別権限で剥奪された」（メニュー非表示）をフロントで区別するために別々に返す（決定74）。
   *
   * @generated from field: repeated api_proto.v1.CompanyFeatureAccess company_features = 11;
   */
  companyFeatures: CompanyFeatureAccess[];

  /**
   * 当該スタッフが保持する権限コード（company_staff_permissions の行あり = 付与）。
   *
   * @generated from field: repeated string staff_permission_codes = 12;
   */
  staffPermissionCodes: string[];

  /**
   * 企業の契約状態（プラン種別ごと。解約後の表示分岐に使う。決定66）。
   *
   * @generated from field: repeated api_proto.v1.CompanyContractState company_contracts = 13;
   */
  companyContracts: CompanyContractState[];

  /**
   * 当該スタッフが所属するプラン種別（company_staff_plan_assignmentsのplan_type。値はcrm / ai_app。決定89(a)）。
   *
   * 企業画面が「業務管理プランに未所属（アカウント枠に入っていない）」ことを判定するために使う。
   * 上の2つとは絞り込みの範囲が違うので組み合わせて読む。company_featuresは所属で絞った実効レベル、
   * company_contractsは絞り込まない企業全体の契約、staff_plan_typesはそのスタッフ自身の所属。
   * 所属そのものを配るので、企業オーバーライドでcrm.*のレベルが動いても未所属判定が揺れない。
   *
   * @generated from field: repeated string staff_plan_types = 14;
   */
  staffPlanTypes: string[];

  /**
   * LINE自然文案件操作を使える条件の判定（準備状態）。判定はサーバ（company_usecase.EvaluateLineReadiness）が行い、
   * フロントは項目ごとの表示とreadyの出し分けだけを担う。設計: doc/architecture/line-deal-operations.md「公開制御」
   *
   * @generated from field: api_proto.v1.LineReadiness line_readiness = 15;
   */
  lineReadiness?: LineReadiness;
};

/**
 * Describes the message api_proto.v1.GetStaffAuthResponse.
 * Use `create(GetStaffAuthResponseSchema)` to create a new message.
 */
export const GetStaffAuthResponseSchema: GenMessage<GetStaffAuthResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_staff, 4);

/**
 * LINE自然文案件操作を使える条件（準備状態）。企業画面ホームのチェックリストと、Adminの企業詳細のスタッフ一覧が使う。
 * readyは下の4つがすべて揃ったときだけtrue。条件の定義と判定はサーバのみが持つ（SSOT。クライアントは再計算しない）
 *
 * @generated from message api_proto.v1.LineReadiness
 */
export type LineReadiness = Message<"api_proto.v1.LineReadiness"> & {
  /**
   * ① スタッフがLINE連携済み（company_staffs.line_idあり）
   *
   * @generated from field: bool linked = 1;
   */
  linked: boolean;

  /**
   * ② AIチャットボット用公式アカウントの友だち状態。readyにはFRIENDが要る（UNKNOWNは未確認として表示する）
   *
   * @generated from field: api_proto.v1.LineBotFriendState friend_state = 2;
   */
  friendState: LineBotFriendState;

  /**
   * ③ 本人に案件の編集権限がある（業務管理の実効権限 crm.deals がfull。rpcpermission.LineRequirement）
   *
   * @generated from field: bool has_deal_edit_permission = 3;
   */
  hasDealEditPermission: boolean;

  /**
   * ④ 企業に自然文案件操作の権限データがある（実効機能集合で crm.line_deal_operation がfull）。
   * 業務管理プランの契約があれば通常true。falseは企業側の設定が未完了で、スタッフ本人には直せない（サポートが対処）
   *
   * @generated from field: bool company_feature_enabled = 4;
   */
  companyFeatureEnabled: boolean;

  /**
   * ①〜④がすべて揃っているか
   *
   * @generated from field: bool ready = 5;
   */
  ready: boolean;
};

/**
 * Describes the message api_proto.v1.LineReadiness.
 * Use `create(LineReadinessSchema)` to create a new message.
 */
export const LineReadinessSchema: GenMessage<LineReadiness> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_staff, 5);

/**
 * LINEのテスト送信（企業画面ホームの「テスト送信」ボタン）。準備状態がreadyのときだけ、
 * AIチャットボット用公式アカウントから使い方の1通をpushする。1日3回まで（スタッフ単位。LINE_TEST_MESSAGE_RATE_LIMITED）。
 * readyでなければLINE_TEST_MESSAGE_NOT_READY、pushが403（友だち未追加）ならLINE_TEST_MESSAGE_NOT_FRIEND
 * （このとき友だち状態をnot_friendに戻すので、取り直したGetStaffMeに反映される）
 *
 * @generated from message api_proto.v1.SendLineTestMessageRequest
 */
export type SendLineTestMessageRequest = Message<"api_proto.v1.SendLineTestMessageRequest"> & {
};

/**
 * Describes the message api_proto.v1.SendLineTestMessageRequest.
 * Use `create(SendLineTestMessageRequestSchema)` to create a new message.
 */
export const SendLineTestMessageRequestSchema: GenMessage<SendLineTestMessageRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_staff, 6);

/**
 * @generated from message api_proto.v1.SendLineTestMessageResponse
 */
export type SendLineTestMessageResponse = Message<"api_proto.v1.SendLineTestMessageResponse"> & {
  /**
   * 送信後の準備状態（pushの結果で友だち状態が変わりうるので返す）
   *
   * @generated from field: api_proto.v1.LineReadiness line_readiness = 1;
   */
  lineReadiness?: LineReadiness;
};

/**
 * Describes the message api_proto.v1.SendLineTestMessageResponse.
 * Use `create(SendLineTestMessageResponseSchema)` to create a new message.
 */
export const SendLineTestMessageResponseSchema: GenMessage<SendLineTestMessageResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_staff, 7);

/**
 * 企業の実効機能集合の 1 要素（契約由来 + 無料体験 + 企業オーバーライド。スタッフ個別権限との積を取る前の値）
 *
 * @generated from message api_proto.v1.CompanyFeatureAccess
 */
export type CompanyFeatureAccess = Message<"api_proto.v1.CompanyFeatureAccess"> & {
  /**
   * go/logic/permissioncode の Code（例 crm.deals）
   *
   * @generated from field: string permission_code = 1;
   */
  permissionCode: string;

  /**
   * readonly / full（none は要素を含めない）
   *
   * @generated from field: string access_level = 2;
   */
  accessLevel: string;

  /**
   * 権限の出どころ（契約 / 無料体験 / 企業オーバーライド）
   *
   * @generated from field: api_proto.v1.FeatureAccessSource source = 3;
   */
  source: FeatureAccessSource;
};

/**
 * Describes the message api_proto.v1.CompanyFeatureAccess.
 * Use `create(CompanyFeatureAccessSchema)` to create a new message.
 */
export const CompanyFeatureAccessSchema: GenMessage<CompanyFeatureAccess> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_staff, 8);

/**
 * 企業の契約状態（プラン種別ごと）
 *
 * @generated from message api_proto.v1.CompanyContractState
 */
export type CompanyContractState = Message<"api_proto.v1.CompanyContractState"> & {
  /**
   * crm / ai_app
   *
   * @generated from field: string plan_type = 1;
   */
  planType: string;

  /**
   * light / standard / premium / enterprise / free
   *
   * @generated from field: string tier = 2;
   */
  tier: string;

  /**
   * active / canceled
   *
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * クレジットを付与する（有料の）営業支援契約か（OwnContract.grants_creditsと同じ値。models.Plan.GrantsCredits）。
   * 業務管理の契約は常にfalse。無料・有料の判定はこの値で行い、段階名では判定しない。
   *
   * @generated from field: optional bool grants_credits = 4;
   */
  grantsCredits?: boolean;
};

/**
 * Describes the message api_proto.v1.CompanyContractState.
 * Use `create(CompanyContractStateSchema)` to create a new message.
 */
export const CompanyContractStateSchema: GenMessage<CompanyContractState> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_staff, 9);

/**
 * LINE 連携フロー開始リクエスト
 *
 * @generated from message api_proto.v1.StartLineLinkRequest
 */
export type StartLineLinkRequest = Message<"api_proto.v1.StartLineLinkRequest"> & {
  /**
   * 認可後のコールバック URI
   *
   * @generated from field: string redirect_uri = 1;
   */
  redirectUri: string;
};

/**
 * Describes the message api_proto.v1.StartLineLinkRequest.
 * Use `create(StartLineLinkRequestSchema)` to create a new message.
 */
export const StartLineLinkRequestSchema: GenMessage<StartLineLinkRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_staff, 10);

/**
 * LINE 連携フロー開始レスポンス
 *
 * @generated from message api_proto.v1.StartLineLinkResponse
 */
export type StartLineLinkResponse = Message<"api_proto.v1.StartLineLinkResponse"> & {
  /**
   * リダイレクト先の LINE 認可 URL
   *
   * @generated from field: string authorize_url = 1;
   */
  authorizeUrl: string;

  /**
   * CSRF 防止用 state
   *
   * @generated from field: string state = 2;
   */
  state: string;
};

/**
 * Describes the message api_proto.v1.StartLineLinkResponse.
 * Use `create(StartLineLinkResponseSchema)` to create a new message.
 */
export const StartLineLinkResponseSchema: GenMessage<StartLineLinkResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_staff, 11);

/**
 * LINE アカウント連携リクエスト（認可コードで LINE userId を紐付け）
 *
 * @generated from message api_proto.v1.LinkLineAccountRequest
 */
export type LinkLineAccountRequest = Message<"api_proto.v1.LinkLineAccountRequest"> & {
  /**
   * LINE から受け取った認可コード
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * 連携フロー開始時に発番した state（CSRF 検証用）
   *
   * @generated from field: string state = 2;
   */
  state: string;
};

/**
 * Describes the message api_proto.v1.LinkLineAccountRequest.
 * Use `create(LinkLineAccountRequestSchema)` to create a new message.
 */
export const LinkLineAccountRequestSchema: GenMessage<LinkLineAccountRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_staff, 12);

/**
 * LINE アカウント連携レスポンス
 *
 * @generated from message api_proto.v1.LinkLineAccountResponse
 */
export type LinkLineAccountResponse = Message<"api_proto.v1.LinkLineAccountResponse"> & {
  /**
   * 連携した LINE の userId
   *
   * @generated from field: string line_id = 1;
   */
  lineId: string;

  /**
   * LINE プロフィールから取得した表示名
   *
   * @generated from field: string display_name = 2;
   */
  displayName: string;
};

/**
 * Describes the message api_proto.v1.LinkLineAccountResponse.
 * Use `create(LinkLineAccountResponseSchema)` to create a new message.
 */
export const LinkLineAccountResponseSchema: GenMessage<LinkLineAccountResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_staff, 13);

/**
 * LINE アカウント連携解除リクエスト
 *
 * @generated from message api_proto.v1.UnlinkLineAccountRequest
 */
export type UnlinkLineAccountRequest = Message<"api_proto.v1.UnlinkLineAccountRequest"> & {
};

/**
 * Describes the message api_proto.v1.UnlinkLineAccountRequest.
 * Use `create(UnlinkLineAccountRequestSchema)` to create a new message.
 */
export const UnlinkLineAccountRequestSchema: GenMessage<UnlinkLineAccountRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_staff, 14);

/**
 * LINE アカウント連携解除レスポンス
 *
 * @generated from message api_proto.v1.UnlinkLineAccountResponse
 */
export type UnlinkLineAccountResponse = Message<"api_proto.v1.UnlinkLineAccountResponse"> & {
};

/**
 * Describes the message api_proto.v1.UnlinkLineAccountResponse.
 * Use `create(UnlinkLineAccountResponseSchema)` to create a new message.
 */
export const UnlinkLineAccountResponseSchema: GenMessage<UnlinkLineAccountResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_staff, 15);

/**
 * AIチャットボット用LINE公式アカウント（AI_BOT）を友だち追加しているかの記録（company_staffs.line_bot_friend_state）。
 * LINEは友だち関係を直接返さないので、観測できた出来事（follow / unfollow / 受信 / pushの403 / プロフィール取得）から推定する。
 *
 * @generated from enum api_proto.v1.LineBotFriendState
 */
export enum LineBotFriendState {
  /**
   * @generated from enum value: LINE_BOT_FRIEND_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 未確認（どの出来事からも確定していない）。「未追加」とは区別して表示する
   *
   * @generated from enum value: LINE_BOT_FRIEND_STATE_UNKNOWN = 1;
   */
  UNKNOWN = 1,

  /**
   * 友だち追加済み
   *
   * @generated from enum value: LINE_BOT_FRIEND_STATE_FRIEND = 2;
   */
  FRIEND = 2,

  /**
   * 友だち未追加（またはブロック中。pushの403・プロフィール取得の404からは区別できない）
   *
   * @generated from enum value: LINE_BOT_FRIEND_STATE_NOT_FRIEND = 3;
   */
  NOT_FRIEND = 3,

  /**
   * ブロック中（unfollowイベントで確定したときだけ）
   *
   * @generated from enum value: LINE_BOT_FRIEND_STATE_BLOCKED = 4;
   */
  BLOCKED = 4,
}

/**
 * Describes the enum api_proto.v1.LineBotFriendState.
 */
export const LineBotFriendStateSchema: GenEnum<LineBotFriendState> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_staff, 0);

/**
 * 権限の出どころ（その機能の実効レベルを最後に決めた段階。決定92）
 *
 * レベルだけでは「契約で full」と「無料体験で full」を区別できないため、フロントが
 * 無料体験の案内を出す機能を選び分けるのに使う。
 *
 * @generated from enum api_proto.v1.FeatureAccessSource
 */
export enum FeatureAccessSource {
  /**
   * 未設定（出どころを載せない旧サーバの応答）
   *
   * @generated from enum value: FEATURE_ACCESS_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 契約（プラン既定の機能セット）
   *
   * @generated from enum value: FEATURE_ACCESS_SOURCE_CONTRACT = 1;
   */
  CONTRACT = 1,

  /**
   * 無料体験（無効化されていない体験クレジットのロット）
   *
   * @generated from enum value: FEATURE_ACCESS_SOURCE_TRIAL = 2;
   */
  TRIAL = 2,

  /**
   * 企業オーバーライド（company_permission_overrides）
   *
   * @generated from enum value: FEATURE_ACCESS_SOURCE_OVERRIDE = 3;
   */
  OVERRIDE = 3,
}

/**
 * Describes the enum api_proto.v1.FeatureAccessSource.
 */
export const FeatureAccessSourceSchema: GenEnum<FeatureAccessSource> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_staff, 1);

